/**
 * Journal des appels — tracés à la main tant qu'aucun standard téléphonique
 * n'est connecté. Le jour où un opérateur (Ringover, Aircall…) enverra ses
 * webhooks, ils alimenteront la MÊME liste : le geste de l'équipe ne changera pas.
 */
import { z } from "zod";

export const AppelSchema = z.object({
  id: z.string(),
  quand: z.string(),
  auteur: z.string().nullable(),
  texte: z.string(),
  cabinetId: z.string().nullable(),
  cabinetNom: z.string().nullable(),
  praticienId: z.string().nullable(),
  praticienNom: z.string().nullable(),
  /** "manuel" aujourd'hui ; "ringover"/"aircall" quand un standard sera branché. */
  source: z.string(),
});
export type Appel = z.infer<typeof AppelSchema>;

export const AppelsResponseSchema = z.object({
  items: z.array(AppelSchema),
  /** Un standard téléphonique est-il relié ? Faux = journal saisi à la main. */
  standardConnecte: z.boolean(),
  jours: z.number().int().min(1),
});
export type AppelsResponse = z.infer<typeof AppelsResponseSchema>;

/**
 * Ce qu'un standard téléphonique a le droit de nous dire : des MÉTADONNÉES.
 * Alerte 10 de la Bible — ni note, ni transcription, ni enregistrement. Le
 * `.strict()` refuse toute clé inconnue AVANT de la lire : un nom de patient
 * glissé dans un champ « note » par un relais mal réglé n'entre pas.
 */
export const DIRECTIONS_APPEL = ["entrant", "sortant"] as const;
export const STATUTS_APPEL = ["repondu", "manque", "messagerie", "en_cours"] as const;
export const AppelEntrantSchema = z
  .object({
    /** identifiant chez l'opérateur — la clé d'idempotence, un rejeu ne duplique pas */
    idOperateur: z.string().trim().min(1).max(128),
    operateur: z.literal("aircall"),
    direction: z.enum(DIRECTIONS_APPEL),
    numero: z.string().trim().min(6).max(32),
    statut: z.enum(STATUTS_APPEL),
    debutLe: z.string().datetime({ offset: true }),
    dureeSecondes: z.number().int().min(0).nullable(),
    agent: z.string().trim().min(1).max(120).nullable(),
  })
  .strict();
export type AppelEntrant = z.infer<typeof AppelEntrantSchema>;
